import { updateRequirement } from './updateRequirementThunk';
export default updateRequirement;
